import { render } from "./overview.vue?vue&type=template&id=1b955d5c"
import script from "./overview.vue?vue&type=script&lang=ts"
export * from "./overview.vue?vue&type=script&lang=ts"
script.render = render

export default script